import { useSearchPanelView } from "../SearchPanel.context";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";

export function useSearchPanelContent<T>() {
  const {
    selectable,
    data,
    idKey,
    ContentComponent,
    onToggleSelect,
    selected = [],
    selectedDisabled,
    moreActions,
    isLoading,
    emptyStateTitle,
    emptyStateMessage,
  } = useSearchPanelView<T>();

  const { mdUp } = useBreakpoints();

  const isEmpty = !isLoading && data.length === 0;

  return {
    selectable,
    data,
    idKey,
    ContentComponent,
    onToggleSelect,
    selected,
    selectedDisabled,
    mdUp,
    moreActions,
    isEmpty,
    emptyStateTitle,
    emptyStateMessage,
  };
}
